<template>
    <div id="task">
        <comheader></comheader>
        <div class="rf ks_right" id="rmodel">
            <comtop></comtop>
            <el-main>
                <div class="com_topaside">
                    <span>培训<b>></b></span>
                    <span>考试管理<b>></b></span>
                    <span>考试任务<b></b></span>
                </div>
            </el-main>
            <el-main class="exam_wrap">
                <el-table :data="taskList" border style="width: 100%" class="exam_table exam_task"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    v-for="info in tHeadr" :key="info.key"     
                    :property="info.key"
                    :label="info.label"
                    :width="info.width"
                >
                <template slot-scope="scope">
                    {{scope.row[scope.column.property]}}  <!-- 渲染对应表格里面的内容 -->
                </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope" class="exam_btn">
                        <el-button @click="opclick(scope.row.t_id)" type="text" size="large">恢复数据</el-button>
                        <el-button type="text" size="large" @click="deltask(scope.row.t_id)" class="exam_delbtn" >彻底删除</el-button>
                    </template>
                </el-table-column>
                </el-table>
                <el-button type="" style="margin-top:20px" @click="delall()">删除选中文件</el-button>
                <el-button type="" style="margin-top:20px" @click="opxz()">恢复选中数据</el-button>
                <el-button type="" style="margin-top:20px" @click="opall()">恢复所有数据</el-button>
                <page :count="count" :Page.sync='page' @pagenation='pagetion'></page>
            </el-main>
        </div>
     
        <dialogFw :visible.sync='visible' :bmid.sync="bmid" @bmidfw="bmidfwtxt"></dialogFw>
    </div>
</template>

<script>
import comheader from '../Common/comheader'
import comtop from '../Common/comtop'
import page from '../Common/page'
import dialogFw from '../Common/dialog'

 export default{
    name:'task',
    inject:["reload"],
    data(){
        return{
            input:'',
            checked:false,
            taskList:[],
            delayTime:false,
            s_time:'',
            delid:'',
            id:'',
            radio:'1',
            uid:localStorage.getItem('userid'),
            visible:false,
            pickerOptionsEnd: {},
            limit:10, //一页几条数据
            count:0, //数据总计
            bmid:0,
            page:1, //当前页数
            e_time:'',
            changeArr:false,
            inGlist:[],
            isCollapse: 0,
            tHeadr: [
                {
                    label: '标题',
                    key: 'title',
                    width:'380'
                },
           
                {
                    label:'创建人',
                    key:'create_name',
                    width:'380'
                },
                {
                    label:'创建时间',
                    key:'s_time',
                    width:'380'
                }
            ],
        }
    },
    components:{
        comheader,
        comtop,
        page,
        dialogFw
    },
    methods:{
        pagetion(limit,page){
            var data=[]
            this.taskList=[]
         var dataUp= {
            service:'Recycle.Data_List',
            userid:this.uid,
            page:page,
            limit:limit
        }
        this.$axios.post(this.HOME,this.$qs.stringify(dataUp))
            .then(res=>{
                this.count=parseInt(res.data.data.count)
                for(let i=0 ;i <res.data.data.info.length;i++){
                data.push(res.data.data.info[i])
                }
          
                this.taskList=data
                this.inGlist=coing
            })
                .catch(function (error) { // 请求失败处理
            });  
        },
        handleSelectionChange(e){
            this.delid = e
        },
        opall(){
            const h = this.$createElement;
             this.$msgbox({
                title: '消息',
                message: h('p', null, [
                h('span', null, '是否一键恢复所有数据')
                ]),
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton:true,
                lockScroll:false,
                showClose:false,
                customClass:'delBtn',
            }).then(action => {
                 var dataUp= {
                    service:'Recycle.Restore_All',
                    userid:this.uid
                }
                this.$axios.post(this.HOME,this.$qs.stringify(dataUp))
                .then(res=>{
                    console.log(res.data.data.code)
                    if(res.data.data.code!=0){
                        this.alertView.failView(res.data.data.msg)
                        return false
                    }
                    this.alertView.successView('恢复成功')
                    this.reload()
                })
                    .catch(function (error) { // 请求失败处理
                });  
            });
        },
        opxz(){
            let tid = this.delid.map(item=>{
                return item.t_id
            })
            tid= tid.join(',')
            const h = this.$createElement;
             this.$msgbox({
                title: '消息',
                message: h('p', null, [
                h('span', null, '是否恢复数据')
                ]),
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton:true,
                lockScroll:false,
                showClose:false,
                customClass:'delBtn',
            }).then(action => {
                 var dataUp= {
                    service:'Recycle.Restore_Multiple',
                    userid:this.uid,
                    t_id:tid
                }
                this.$axios.post(this.HOME,this.$qs.stringify(dataUp))
                .then(res=>{
                    console.log(res.data.data.code)
                    if(res.data.data.code!=0){
                        this.alertView.failView(res.data.data.msg)
                        return false
                    }
                    this.alertView.successView('恢复成功')
                    this.reload()
                })
                    .catch(function (error) { // 请求失败处理
                });  
            });
        },
        delall(){
           let tid = this.delid.map(item=>{
                return item.t_id
            })
            tid= tid.join(',')
            const h = this.$createElement;
             this.$msgbox({
                title: '消息',
                message: h('p', null, [
                h('span', null, '是否删除数据')
                ]),
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton:true,
                lockScroll:false,
                showClose:false,
                customClass:'delBtn',
            }).then(action => {
                 var dataUp= {
                    service:'Recycle.Delete_Multiple',
                    userid:this.uid,
                    t_ids:tid
                }
                this.$axios.post(this.HOME,this.$qs.stringify(dataUp))
                .then(res=>{
                    console.log(res.data.data.code)
                    if(res.data.data.code!=0){
                        this.alertView.failView(res.data.data.msg)
                        return false
                    }
                    this.alertView.successView('删除成功')
                    this.reload()
                })
                    .catch(function (error) { // 请求失败处理
                });  
            })
        },
        opclick(tid){
             const h = this.$createElement;
             this.$msgbox({
                title: '消息',
                message: h('p', null, [
                h('span', null, '是否恢复数据')
                ]),
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton:true,
                lockScroll:false,
                showClose:false,
                customClass:'delBtn',
            }).then(action => {
                 var dataUp= {
                    service:'Recycle.Restore_Single',
                    userid:this.uid,
                    t_id:tid
                }
                this.$axios.post(this.HOME,this.$qs.stringify(dataUp))
                .then(res=>{
                    console.log(res.data.data.code)
                    if(res.data.data.code!=0){
                        this.alertView.failView(res.data.data.msg)
                        return false
                    }
                    this.alertView.successView('恢复成功')
                    this.reload()
                })
                    .catch(function (error) { // 请求失败处理
                });  
            });
           
        },
        deltask(tid){
              var dataUp= {
                service:'Recycle.Delete_Multiple',
                userid:this.uid,
                t_ids:tid
            }
            const h = this.$createElement;
             this.$msgbox({
                title: '消息',
                message: h('p', null, [
                h('span', null, '是否确定删除')
                ]),
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton:true,
                lockScroll:false,
                showClose:false,
                customClass:'delBtn',
            }).then(action => {
                this.$axios.post(this.HOME,this.$qs.stringify(dataUp))
                    .then(res=>{
                        console.log(res.data.data.code)
                        if(res.data.data.code!=0){
                            this.alertView.failView(res.data.data.msg)
                            return false
                        }
                        this.alertView.successView('删除成功')
                        this.reload()
                    })
                        .catch(function (error) { // 请求失败处理
                    });  
            });
        },
    },
        
    mounted(){
    var data=[]
    var coing = []
    var dataUp= {
            service:'Recycle.Data_List',
            userid:this.uid,
            page:1,
            limit:10
        }
        this.$axios.post(this.HOME,this.$qs.stringify(dataUp))
            .then(res=>{
                this.count=parseInt(res.data.data.count)
                for(let i=0 ;i <res.data.data.info.length;i++){
                data.push(res.data.data.info[i])
                }
          
                this.taskList=data
                this.inGlist=coing
            })
                .catch(function (error) { // 请求失败处理
            });  
    }
 }
</script>
<style>
    @import "../../assets/css/task.css";
</style>


// WEBPACK FOOTER //
// src/components/recycle/index.vue